<template>

</template>

<script>

export default {
  name: 'logout',
  created () {
    this.$emit('logout')
  }
}
</script>
